import { Stack, Typography } from '@mui/material';

import { File05Icon } from '@/components/icons/File05Icon';
import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { Tooltip } from '@/components/poppers/Tooltip/Tooltip';
import { COLORS } from '@/styles/tokens/colors';

interface SummarySourceDocument {
  id: string;
  name: string;
}

export function CombinedSummarySources({
  sourceDocuments,
  showDetails = false,
}: {
  sourceDocuments: readonly SummarySourceDocument[];
  showDetails?: boolean;
}) {
  const documentCount = sourceDocuments.length;
  const sourceIndicator = (
    <Badge
      component="span"
      variant={BadgeVariants.SecondaryFilled}
      display={
        <>
          <File05Icon size={16} />
          {documentCount}
        </>
      }
      sx={{ height: 22 }}
      wrapperSx={{ display: 'inline-flex' }}
    />
  );

  if (!showDetails) return sourceIndicator;

  return (
    <Tooltip
      disableFocusListener
      placement="bottom-start"
      tabIndex={-1}
      title={
        <Stack spacing={1} maxWidth={320}>
          <Typography variant="eyebrow-xs" sx={{ color: COLORS.TEXT.PRIMARY }}>
            Combined from {documentCount} documents
          </Typography>
          {sourceDocuments.map((document) => (
            <Typography
              key={document.id}
              variant="body-xs"
              sx={{ color: COLORS.TEXT.PRIMARY }}
            >
              {document.name}
            </Typography>
          ))}
        </Stack>
      }
    >
      {sourceIndicator}
    </Tooltip>
  );
}
